import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=dc870380&scoped=true"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&id=dc870380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc870380",
  null
  
)

export default component.exports